import { CURRENCY, PERIODS } from '../constants/constants';

export const savePeriods = (tariffs, productId) => ({
    type: PERIODS,
    data: { tariffs, productId },
});

export const saveCurrencies = (currencies) => ({
    type: CURRENCY,
    data: currencies,
});
